"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitReplaceVTO = void 0;
const fetchClient_1 = require("../../client/fetchClient");
const react_1 = require("react");
const react_query_1 = require("react-query");
const paths_1 = require("../../paths");
const taaEvents_1 = require("../../utils/EventEmitter/taaEvents");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const useCatalystCreateCase_1 = require("../../hooks/useCatalystCreateCase");
function useSubmitReplaceVTO({ employeeId }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { catalystCreateCaseState: { data: createCaseResponse, loading: createCaseLoading, error: createCaseError }, catalystCreateCase } = (0, useCatalystCreateCase_1.useCatalystCreateCase)({ employeeId });
    const putToS3Bucket = (preSignedUrl, csvData) => __awaiter(this, void 0, void 0, function* () {
        const myHeaders = new Headers({ 'Content-Type': 'text/csv' });
        yield fetch(preSignedUrl, {
            method: 'PUT',
            headers: myHeaders,
            body: new Blob([csvData], { type: 'text/csv' })
        });
    });
    const { data: getUploadUrlData, isLoading: submitReplaceVTOLoading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    (0, react_1.useEffect)(() => {
        if (submitReplaceVTOLoading) {
            setIsLoading(submitReplaceVTOLoading);
        }
        if (!createCaseLoading && (createCaseResponse || createCaseError)) {
            setData(createCaseResponse);
            setIsLoading(false);
        }
    }, [submitReplaceVTOLoading, createCaseLoading, createCaseResponse]);
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)(undefined);
    const path = (0, paths_1.SUBMIT_TRAVEL_TIME_API)({
        'x-myhr-client-id': 'MyHR_Catalyst',
        operation: '/get-upload-url',
        employeeId: employeeId
    });
    const method = 'POST';
    const apiName = 'submitReplaceVTO';
    const submitReplaceVTO = (payload, attachmentPayload, csvData, duration) => {
        setRetryParams(undefined);
        mutate({
            path,
            method,
            eventName: taaEvents_1.taaEvents.CREATE_CTK_CASE,
            body: {
                messageMetadata: {
                    employeeId: employeeId,
                    origin: 'ATOZTimeCard'
                },
                businessOwner: 'ATOZ-TimeCard-CentralizedTimeKeeping'
            },
            metaData: {
                apiName,
                clientName,
                isLogResponse: true
            }
        }, {
            onSuccess: (data, variables, context) => {
                const res = JSON.parse(data.response);
                putToS3Bucket(res.preSignedUrl, csvData)
                    .then(() => {
                    console.log('PUT to S3 done, Create case catalyst next step');
                    attachmentPayload[0].s3FilePath = res.s3FilePath;
                    catalystCreateCase(payload, attachmentPayload, duration);
                })
                    .catch((err) => console.log('Error while put to s3 : ', err.message));
            },
            onError: (err) => {
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.CATALYST_GET_UPLOAD_URL_ERROR.COUNT,
                    dimensions
                });
                setRetryParams({ payload, attachmentPayload, csvData, duration });
            }
        });
    };
    const retry = () => {
        if (!retryParams || submitReplaceVTOLoading)
            return;
        const { payload, attachmentPayload, csvData, duration } = retryParams;
        submitReplaceVTO(payload, attachmentPayload, csvData, duration);
    };
    return {
        submitReplaceVTOState: {
            data: data,
            loading: isLoading,
            error: retryParams ? error || createCaseError : null,
            retry
        },
        submitReplaceVTO
    };
}
exports.useSubmitReplaceVTO = useSubmitReplaceVTO;
